<template>
  <div class="register-candidate-form-block">
    <div
      v-if="header || $slots.header"
      class="register-candidate-form-block__header-wrap"
    >
      <slot name="header">
        <div class="register-candidate-form-block__header-rectangle"></div>
        <h3 class="register-candidate-form-block__header">{{ header }}</h3>
        <div v-if="subheader" class="register-candidate-form-block__subheader">({{ subheader }})</div>
      </slot>
    </div>

    <div :class="{ 'pa-0': !$slots.default }" class="register-candidate-form-block__content">
      <slot name="default"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterCandidateFormBlock',
  props: {
    header: {
      type: String,
      default: '',
    },
    subheader: {
      type: String,
      default: '',
    },
  },
};
</script>
